'use strict';

var lightMobile375;
var hasRequiredLightMobile375;

function requireLightMobile375 () {
	if (hasRequiredLightMobile375) return lightMobile375;
	hasRequiredLightMobile375 = 1;

	/**
	 * Do not edit directly, this file was auto-generated.
	 */

	lightMobile375 = {
	  "theme": "light-mobile375",
	  "type": {
	    "family": {
	      "base": "Mulish",
	      "decorative": "Besley"
	    }
	  },
	  "borderWeight": {
	    "medium": 2,
	    "small": 1,
	    "xsmall": 1
	  },
	  "column": {
	    "app": {
	      "container": 375,
	      "gutter": 20,
	      "margin": 20
	    },
	    "web": {
	      "container": 1440,
	      "gutter": 16,
	      "margin": 20
	    }
	  },
	  "gap": {
	    "0": 0,
	    "25": 1,
	    "50": 2,
	    "100": 4,
	    "200": 8,
	    "300": 12,
	    "400": 16,
	    "500": 20,
	    "600": 24,
	    "800": 32,
	    "1000": 40,
	    "1200": 48,
	    "1600": 64,
	    "3600": 144
	  },
	  "padding": {
	    "dynamic": {
	      "200": 4,
	      "400": 8,
	      "600": 16,
	      "800": 16,
	      "1000": 24,
	      "1200": 24
	    },
	    "static": {
	      "25": 1,
	      "50": 2,
	      "100": 4,
	      "150": 6,
	      "200": 8,
	      "300": 12,
	      "400": 16,
	      "500": 20,
	      "600": 24,
	      "800": 32,
	      "1000": 40,
	      "1200": 48,
	      "1400": 56,
	      "1600": 64,
	      "4125": 165
	    }
	  },
	  "radius": {
	    "background": {
	      "large": 16,
	      "medium": 8,
	      "rounded": 300,
	      "small": 4,
	      "xlarge": 32,
	      "xsmall": 3
	    },
	    "surface": {
	      "large": 16,
	      "medium": 8,
	      "small": 4,
	      "xlarge": 32
	    }
	  },
	  "size": {
	    "height": {
	      "25": 1,
	      "75": 3,
	      "100": 4,
	      "150": 6,
	      "200": 8,
	      "300": 12,
	      "350": 14,
	      "400": 16,
	      "450": 18,
	      "475": 19,
	      "500": 20,
	      "525": 21,
	      "600": 24,
	      "675": 27,
	      "700": 28,
	      "800": 32,
	      "850": 34,
	      "1000": 40,
	      "1050": 42,
	      "1100": 44,
	      "1300": 52,
	      "1400": 56,
	      "1550": 62,
	      "1600": 64,
	      "2000": 80,
	      "2200": 88,
	      "2750": 110,
	      "3000": 120,
	      "3650": 146,
	      "4000": 160,
	      "5000": 200,
	      "5600": 224,
	      "8375": 335,
	      "14600": 584,
	      "146003": 584
	    },
	    "width": {
	      "25": 1,
	      "150": 6,
	      "200": 8,
	      "300": 12,
	      "350": 14,
	      "400": 16,
	      "450": 18,
	      "500": 20,
	      "600": 24,
	      "700": 28,
	      "800": 32,
	      "850": 34,
	      "950": 38,
	      "1000": 40,
	      "1050": 42,
	      "1100": 44,
	      "1300": 52,
	      "1400": 56,
	      "1550": 62,
	      "1600": 64,
	      "2000": 80,
	      "2200": 88,
	      "2350": 94,
	      "2750": 110,
	      "3000": 120,
	      "3650": 146,
	      "4000": 160,
	      "5000": 200,
	      "5250": 210,
	      "5600": 224,
	      "6500": 260,
	      "7500": 300,
	      "8375": 335,
	      "14600": 584
	    }
	  },
	  "asset": {
	    "blue": {
	      "100": "#f5faff",
	      "200": "#e6f1fc",
	      "300": "#c0d8f0",
	      "400": "#88b1d9",
	      "500": "#5d96cf",
	      "600": "#3971a8",
	      "700": "#21588f",
	      "800": "#194673",
	      "900": "#143657",
	      "background": "#c0d8f0",
	      "backItem": "#5d96cf"
	    },
	    "green": {
	      "100": "#fafffc",
	      "200": "#ebf2ef",
	      "300": "#d1e0d9",
	      "400": "#b6cfc2",
	      "500": "#86b09b",
	      "600": "#307553",
	      "700": "#275e43",
	      "800": "#244c38",
	      "900": "#0f3d26",
	      "background": "#d1e0d9",
	      "backItem": "#86b09b"
	    },
	    "grey": {
	      "100": "#fcfeff",
	      "200": "#f5f7fa",
	      "300": "#e6edf5",
	      "400": "#e6edf5",
	      "500": "#596d84",
	      "600": "#475a70",
	      "700": "#36485c",
	      "800": "#2e3a47",
	      "900": "#212933",
	      "background": "#c8d3e0",
	      "backItem": "#596d84"
	    },
	    "orange": {
	      "100": "#fffaf5",
	      "200": "#fff3e8",
	      "300": "#f3d8c0",
	      "400": "#e7b88f",
	      "500": "#cf8545",
	      "600": "#b4631d",
	      "700": "#8e4d14",
	      "800": "#784213",
	      "900": "#693a11",
	      "background": "#f3d8c0",
	      "backItem": "#cf8545"
	    },
	    "purple": {
	      "100": "#fcfaff",
	      "200": "#f2ecfe",
	      "300": "#d7cee9",
	      "400": "#b9abd5",
	      "500": "#8471ab",
	      "600": "#533e7d",
	      "700": "#3b2566",
	      "800": "#2a174f",
	      "900": "#17043e",
	      "background": "#d7cee9",
	      "backItem": "#8471ab"
	    },
	    "red": {
	      "100": "#fff7f9",
	      "200": "#feeef2",
	      "300": "#f0c4cd",
	      "400": "#e296a6",
	      "500": "#c6516a",
	      "600": "#af2645",
	      "700": "#980b29",
	      "800": "#800d25",
	      "900": "#68182a",
	      "background": "#f0c4cd",
	      "backItem": "#c6516a"
	    },
	    "sand": {
	      "100": "#ffffff",
	      "200": "#f6f1e5",
	      "300": "#e9e1ce",
	      "400": "#d9cdb0",
	      "500": "#c1af86",
	      "600": "#9e8c61",
	      "700": "#72623e",
	      "800": "#5e4d27",
	      "900": "#3e3114",
	      "background": "#e9e1ce",
	      "backItem": "#c1af86"
	    },
	    "shade": {
	      "white": "#ffffff"
	    }
	  },
	  "accent": {
	    "blue": {
	      "backgroundBold": "#3971a8",
	      "backgroundLevel1": "#e6f1fc",
	      "backgroundLevel2": "#c0d8f0",
	      "border": "#3971a8",
	      "icon": "#21588f",
	      "text": "#21588f",
	      "textBold": "#194673"
	    },
	    "green": {
	      "backgroundBold": "#307553",
	      "backgroundLevel1": "#ebf2ef",
	      "backgroundLevel2": "#d1e0d9",
	      "border": "#275e43",
	      "borderBold": "#0f3d26",
	      "icon": "#275e43",
	      "iconBold": "#0f3d26",
	      "text": "#275e43",
	      "textBold": "#244c38"
	    },
	    "orange": {
	      "backgroundBold": "#8e4d14",
	      "backgroundLevel1": "#fff3e8",
	      "backgroundLevel2": "#f3d8c0",
	      "border": "#b4631d",
	      "icon": "#8e4d14",
	      "text": "#8e4d14",
	      "textBold": "#784213"
	    },
	    "purple": {
	      "backgroundBold": "#533e7d",
	      "backgroundLevel1": "#f2ecfe",
	      "backgroundLevel2": "#d7cee9",
	      "border": "#533e7d",
	      "icon": "#3b2566",
	      "text": "#3b2566",
	      "textBold": "#2a174f"
	    },
	    "red": {
	      "backgroundBold": "#af2645",
	      "backgroundLevel1": "#feeef2",
	      "backgroundLevel2": "#f0c4cd",
	      "border": "#af2645",
	      "icon": "#980b29",
	      "text": "#980b29",
	      "textBold": "#800d25"
	    }
	  },
	  "brand": {
	    "apple": {
	      "button": {
	        "border": "#000000",
	        "fill": "#ffffff",
	        "text": "#000000"
	      },
	      "icon": "#000000"
	    },
	    "emerson": {
	      "gold": "#dca270",
	      "silver": "#949494"
	    },
	    "facebook": {
	      "logo": "#3c5a99"
	    },
	    "fullscript": {
	      "logo": {
	        "leaf": "#88b04b",
	        "wordmark": "#36485c"
	      }
	    },
	    "google": {
	      "button": {
	        "border": "#000000",
	        "fill": "#ffffff",
	        "text": "#000000"
	      },
	      "icon": {
	        "blue": "#4285f4",
	        "green": "#34a853",
	        "red": "#ea4335",
	        "yellow": "#fbbc05"
	      }
	    },
	    "linkedin": {
	      "logo": "#2867b2"
	    },
	    "twitterX": {
	      "logo": "#000000"
	    }
	  },
	  "critical": {
	    "backgroundBold": "#af2645",
	    "backgroundLevel1": "#feeef2",
	    "backgroundLevel2": "#f0c4cd",
	    "border": "#af2645",
	    "icon": "#980b29",
	    "text": "#980b29",
	    "textBold": "#800d25"
	  },
	  "discovery": {
	    "backgroundBold": "#9e8c61",
	    "backgroundLevel1": "#f6f1e5",
	    "backgroundLevel2": "#e9e1ce",
	    "border": "#9e8c61",
	    "icon": "#72623e",
	    "text": "#72623e",
	    "textBold": "#5e4d27"
	  },
	  "info": {
	    "backgroundBold": "#3971a8",
	    "backgroundLevel1": "#e6f1fc",
	    "backgroundLevel2": "#c0d8f0",
	    "border": "#3971a8",
	    "icon": "#21588f",
	    "text": "#21588f",
	    "textBold": "#194673"
	  },
	  "inverse": {
	    "backgroundBold": "#212933",
	    "backgroundMuted": "#36485c",
	    "border": "#212933",
	    "borderBold": "#ffffff",
	    "icon": "#f5f7fa",
	    "iconBold": "#ffffff",
	    "text": "#f5f7fa",
	    "textBold": "#ffffff"
	  },
	  "neutral": {
	    "backgroundLevel0": "#ffffff",
	    "backgroundLevel1": "#f5f7fa",
	    "backgroundLevel2": "#e6edf5",
	    "backgroundLevel3": "#c8d3e0",
	    "border": "#b8c6d6",
	    "borderBold": "#596d84",
	    "borderMuted": "#f5f7fa",
	    "divider": "#c8d3e0",
	    "icon": "#36485c",
	    "iconBold": "#2e3a47",
	    "text": "#36485c",
	    "textBold": "#2e3a47",
	    "textSubtle": "#475a70"
	  },
	  "recur": {
	    "backgroundBold": "#533e7d",
	    "backgroundLevel1": "#f2ecfe",
	    "backgroundLevel2": "#d7cee9",
	    "border": "#533e7d",
	    "icon": "#3b2566",
	    "text": "#3b2566",
	    "textBold": "#2a174f"
	  },
	  "smart": {
	    "backgroundBold1": "#7495b9",
	    "backgroundBold2": "#4d7199",
	    "backgroundBold3": "#2e5988"
	  },
	  "success": {
	    "backgroundBold": "#307553",
	    "backgroundLevel1": "#ebf2ef",
	    "backgroundLevel2": "#d1e0d9",
	    "border": "#307553",
	    "icon": "#275e43",
	    "text": "#275e43",
	    "textBold": "#244c38"
	  },
	  "surface": {
	    "inverse": "#2e3a47",
	    "level0": "#ffffff",
	    "level1": "#f5f7fa",
	    "overflow": "#ffffff",
	    "overlay": "#ffffff",
	    "overlayBackdrop": "#00000033",
	    "overlayInverted": "#2e3a47",
	    "raised": "#ffffff"
	  },
	  "warning": {
	    "backgroundBold": "#8e4d14",
	    "backgroundLevel1": "#fff3e8",
	    "backgroundLevel2": "#f3d8c0",
	    "border": "#b4631d",
	    "icon": "#8e4d14",
	    "text": "#8e4d14",
	    "textBold": "#784213"
	  },
	  "effect": {
	    "blur": {
	      "price": 6
	    },
	    "elevation": {
	      "overflow": {
	        "blur": 8,
	        "colour": "#36485c29",
	        "opacity": 16,
	        "spread": 0,
	        "x": 0,
	        "y": -2
	      },
	      "overflowFade": "#212933",
	      "overlay": {
	        "blur": 16,
	        "colour": "#36485c29",
	        "opacity": 16,
	        "spread": 0,
	        "x": 0,
	        "y": 4
	      },
	      "raised": {
	        "blur": 6,
	        "colour": "#36485c29",
	        "opacity": 16,
	        "spread": 0,
	        "x": 0,
	        "y": 2
	      }
	    },
	    "focused": {
	      "border": "#015fcc",
	      "stroke": 2
	    },
	    "overlay": "#0000001f",
	    "skeleton": {
	      "backgroundLevel0": "#f5f7fa00",
	      "backgroundLevel1": "#e6edf580",
	      "backgroundLevel2": "#c8d3e0",
	      "radius": 4
	    },
	    "state": {
	      "disabled": {
	        "opacity": "0.5"
	      },
	      "hovered": {
	        "background": "#00000014",
	        "backgroundBold": "#00000029",
	        "border": "#00000014",
	        "borderBold": "#00000047",
	        "icon": "#00000014",
	        "iconBold": "#00000029",
	        "inverse": {
	          "background": "#ffffff14",
	          "backgroundBold": "#ffffff29",
	          "border": "#ffffff14",
	          "borderBold": "#ffffff47",
	          "icon": "#ffffff14",
	          "text": "#ffffff14"
	        },
	        "text": "#00000014",
	        "textBold": "#00000029"
	      },
	      "pressed": {
	        "background": "#00000029",
	        "backgroundBold": "#00000047",
	        "border": "#00000029",
	        "borderBold": "#000000cc",
	        "icon": "#00000029",
	        "iconBold": "#00000047",
	        "inverse": {
	          "background": "#ffffff29",
	          "backgroundBold": "#ffffff47",
	          "border": "#ffffff29",
	          "borderBold": "#ffffffcc",
	          "icon": "#ffffff29",
	          "text": "#ffffff29"
	        },
	        "text": "#00000029",
	        "textBold": "#00000047"
	      },
	      "readOnly": {
	        "opacity": "0.8"
	      },
	      "shortPressed": {
	        "opacity": "0.7"
	      }
	    }
	  },
	  "typography": {
	    "letterSpacing": {
	      "body": 0,
	      "heading": 0,
	      "label": 0,
	      "title": 0
	    },
	    "lineHeight": {
	      "bodyLg": 26,
	      "bodyMd": 23,
	      "bodySm": 20,
	      "bodyXs": 17,
	      "headingLg": 55,
	      "headingMd": 50,
	      "headingSm": 43,
	      "labelLg": 26,
	      "labelMd": 23,
	      "labelSm": 20,
	      "labelXs": 17,
	      "titleLg": 38,
	      "titleMd": 28,
	      "titleSm": 24
	    },
	    "textSize": {
	      "bodyLg": 17,
	      "bodyMd": 15,
	      "bodySm": 13,
	      "bodyXs": 11,
	      "headingLg": 34,
	      "headingMd": 31,
	      "headingSm": 27,
	      "labelLg": 17,
	      "labelMd": 15,
	      "labelSm": 13,
	      "labelXs": 11,
	      "titleLg": 24,
	      "titleMd": 22,
	      "titleSm": 19
	    }
	  },
	  "weight": {
	    "bold": "700",
	    "medium": "500",
	    "regular": "400",
	    "semibold": "600"
	  },
	  "accordionN": {
	    "background": "#ffffff",
	    "border": "#b8c6d6",
	    "borderWeight": 1,
	    "gap": 16,
	    "paddingY": 20,
	    "radius": 8,
	    "text": "#36485c"
	  },
	  "avatarN": {
	    "backgroundAvatar": "#e6edf5",
	    "height": {
	      "large": 120,
	      "medium": 80,
	      "small": 56,
	      "xsmall": 40
	    },
	    "lineHeight": 41,
	    "radius": 300,
	    "text": "#2e3a47",
	    "textSize": 32,
	    "width": {
	      "large": 120,
	      "medium": 80,
	      "small": 56,
	      "xsmall": 40
	    }
	  },
	  "badgeN": {
	    "critical": {
	      "background": "#af2645",
	      "text": "#f5f7fa"
	    },
	    "height": {
	      "medium": 20,
	      "small": 12,
	      "xsmall": 8
	    },
	    "inverse": {
	      "background": "#e6edf5",
	      "text": "#36485c"
	    },
	    "neutral": {
	      "background": "#212933",
	      "text": "#f5f7fa"
	    },
	    "paddingX": 4,
	    "paddingY": 4,
	    "radius": 300,
	    "recur": {
	      "background": "#533e7d",
	      "text": "#f5f7fa"
	    },
	    "success": {
	      "background": "#307553",
	      "text": "#f5f7fa"
	    },
	    "width": {
	      "medium": 20,
	      "small": 12,
	      "xsmall": 8
	    }
	  },
	  "boxN": {
	    "alternate": {
	      "background": "#ffffff",
	      "border": "#b8c6d6"
	    },
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "discovery": {
	      "background": "#f6f1e5",
	      "border": "#9e8c61"
	    },
	    "info": {
	      "background": "#e6f1fc",
	      "border": "#3971a8"
	    },
	    "neutral": {
	      "background": "#f5f7fa",
	      "border": "#b8c6d6"
	    },
	    "paddingX": {
	      "large": 16,
	      "small": 8,
	      "xsmall": 4
	    },
	    "paddingY": {
	      "large": 16,
	      "small": 8,
	      "xsmall": 4
	    },
	    "recur": {
	      "background": "#f2ecfe",
	      "border": "#533e7d"
	    },
	    "slot": {
	      "border": "#b8c6d6",
	      "icon": "#36485c",
	      "text": "#2e3a47"
	    },
	    "success": {
	      "background": "#ebf2ef",
	      "border": "#307553"
	    },
	    "warning": {
	      "background": "#fff3e8",
	      "border": "#b4631d"
	    }
	  },
	  "buttonN": {
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "buttonBase": {
	      "icon": {
	        "critical": "#980b29",
	        "discovery": "#72623e",
	        "info": "#21588f",
	        "neutral": "#2e3a47",
	        "recur": "#3b2566",
	        "success": "#275e43",
	        "warning": "#8e4d14"
	      },
	      "text": {
	        "critical": "#800d25",
	        "discovery": "#5e4d27",
	        "info": "#194673",
	        "neutral": "#2e3a47",
	        "recur": "#2a174f",
	        "success": "#244c38",
	        "warning": "#784213"
	      }
	    },
	    "gap": 8,
	    "height": {
	      "medium": 44,
	      "small": 34
	    },
	    "paddingX": 16,
	    "primary": {
	      "critical": {
	        "background": "#af2645",
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      },
	      "inverse": {
	        "background": "#f5f7fa",
	        "icon": "#36485c",
	        "text": "#2e3a47"
	      },
	      "neutral": {
	        "background": "#36485c",
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      },
	      "smart": {
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      }
	    },
	    "secondary": {
	      "critical": {
	        "background": "#af2645",
	        "border": "#af2645",
	        "icon": "#980b29",
	        "iconAlt": "#f5f7fa",
	        "text": "#980b29",
	        "textAlt": "#ffffff"
	      },
	      "inverse": {
	        "border": "#f5f7fa",
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      },
	      "neutral": {
	        "border": "#212933",
	        "icon": "#36485c",
	        "text": "#2e3a47"
	      },
	      "smart": {
	        "icon": "#36485c",
	        "iconAlt": "#ffffff",
	        "text": "#2e3a47",
	        "textAlt": "#ffffff"
	      }
	    },
	    "ssoButtonN": {
	      "apple": {
	        "background": "#ffffff",
	        "border": "#000000",
	        "icon": "#000000",
	        "text": "#000000"
	      },
	      "borderWeight": 1,
	      "gap": 12,
	      "google": {
	        "background": "#ffffff",
	        "border": "#000000",
	        "icon": {
	          "blue": "#4285f4",
	          "green": "#34a853",
	          "red": "#ea4335",
	          "yellow": "#fbbc05"
	        },
	        "text": "#000000"
	      },
	      "height": 44,
	      "padding": 16,
	      "radius": 8
	    },
	    "tertiary": {
	      "inverse": {
	        "icon": "#f5f7fa",
	        "text": "#ffffff"
	      },
	      "neutral": {
	        "icon": "#36485c",
	        "text": "#2e3a47"
	      }
	    },
	    "width": {
	      "large": 52,
	      "medium": 44,
	      "small": 34
	    }
	  },
	  "carouselN": {
	    "borderRadius": 8,
	    "gap": {
	      "large": 16,
	      "medium": 12,
	      "small": 8
	    }
	  },
	  "checkboxN": {
	    "background": {
	      "default": "#ffffff",
	      "selected": "#212933"
	    },
	    "border": "#596d84",
	    "borderRadius": 3,
	    "borderWeight": 1,
	    "gap": 16,
	    "height": {
	      "large": 34,
	      "small": 18
	    },
	    "icon": "#f5f7fa",
	    "text": "#36485c",
	    "width": {
	      "large": 34,
	      "small": 18
	    }
	  },
	  "chipN": {
	    "background": "#ffffff",
	    "border": "#b8c6d6",
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "gap": {
	      "small": 8,
	      "xsmall": 4
	    },
	    "icon": "#36485c",
	    "minheight": 34,
	    "multi": {
	      "background": {
	        "selected": "#c8d3e0"
	      }
	    },
	    "paddingL": {
	      "medium": 12,
	      "small": 8
	    },
	    "paddingR": {
	      "medium": 12,
	      "small": 8
	    },
	    "paddingX": 12,
	    "paddingY": 4,
	    "single": {
	      "background": {
	        "selected": "#36485c"
	      },
	      "text": {
	        "selected": "#f5f7fa"
	      }
	    },
	    "text": "#2e3a47"
	  },
	  "dividerN": {
	    "border": "#c8d3e0",
	    "borderWeight": 1,
	    "gap": 16,
	    "height": 20,
	    "text": "#475a70"
	  },
	  "emptyStateN": {
	    "background": "#ffffff",
	    "border": "#b8c6d6",
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "gap": {
	      "medium": 16,
	      "small": 8
	    },
	    "paddingX": 24,
	    "paddingY": 24,
	    "textBody": "#36485c",
	    "textHeading": "#2e3a47"
	  },
	  "headingN": {
	    "background": "#ffffff",
	    "paddingB": {
	      "large": 20,
	      "medium": 12,
	      "small": 8,
	      "xsmall": 4
	    },
	    "paddingY": 20,
	    "text": "#36485c"
	  },
	  "iconButtonN": {
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "height": {
	      "large": 52,
	      "medium": 44,
	      "small": 34
	    },
	    "primary": {
	      "critical": {
	        "background": "#af2645",
	        "icon": "#f5f7fa"
	      },
	      "inverse": {
	        "background": "#f5f7fa",
	        "icon": "#36485c"
	      },
	      "neutral": {
	        "background": "#36485c",
	        "icon": "#f5f7fa"
	      },
	      "smart": {
	        "icon": "#f5f7fa"
	      }
	    },
	    "secondary": {
	      "critical": {
	        "background": "#af2645",
	        "border": "#af2645",
	        "icon": "#980b29",
	        "iconAlt": "#f5f7fa"
	      },
	      "inverse": {
	        "border": "#f5f7fa",
	        "icon": "#f5f7fa"
	      },
	      "neutral": {
	        "border": "#212933",
	        "icon": "#36485c"
	      },
	      "smart": {
	        "icon": "#36485c",
	        "iconAlt": "#ffffff"
	      }
	    },
	    "tertiary": {
	      "inverse": {
	        "icon": "#f5f7fa"
	      },
	      "neutral": {
	        "icon": "#36485c"
	      }
	    },
	    "width": {
	      "large": 52,
	      "medium": 44,
	      "small": 34
	    }
	  },
	  "iconN": {
	    "alternate": {
	      "background": "#ffffff",
	      "icon": "#36485c"
	    },
	    "background": "#e6edf5",
	    "backgroundHeight": {
	      "large": 52,
	      "medium": 44,
	      "small": 34,
	      "xlarge": 64,
	      "xsmall": 24
	    },
	    "backgroundWidth": {
	      "large": 52,
	      "medium": 44,
	      "small": 34,
	      "xlarge": 64,
	      "xsmall": 24
	    },
	    "borderRadius": {
	      "circular": 300,
	      "rectangular": 8
	    },
	    "critical": {
	      "background": "#f0c4cd",
	      "icon": "#980b29"
	    },
	    "discovery": {
	      "background": "#e9e1ce",
	      "icon": "#72623e"
	    },
	    "iconHeight": {
	      "large": 24,
	      "medium": 20,
	      "small": 16,
	      "xsmall": 14
	    },
	    "iconWidth": {
	      "large": 24,
	      "medium": 20,
	      "small": 16,
	      "xsmall": 14
	    },
	    "info": {
	      "background": "#c0d8f0",
	      "icon": "#21588f"
	    },
	    "inverse": {
	      "background": "#36485c",
	      "icon": "#f5f7fa"
	    },
	    "neutral": {
	      "background": "#e6edf5",
	      "icon": "#36485c"
	    },
	    "recur": {
	      "background": "#d7cee9",
	      "icon": "#3b2566"
	    },
	    "success": {
	      "background": "#d1e0d9",
	      "icon": "#275e43"
	    },
	    "warning": {
	      "background": "#f3d8c0",
	      "icon": "#8e4d14"
	    }
	  },
	  "inputN": {
	    "background": "#ffffff",
	    "borderRadius": 8,
	    "borderWeight": 1,
	    "critical": {
	      "border": "#af2645",
	      "icon": "#980b29",
	      "text": "#980b29"
	    },
	    "gap": 16,
	    "height": {
	      "large": 52,
	      "small": 28
	    },
	    "iconHeight": 24,
	    "iconWidth": 24,
	    "neutral": {
	      "border": "#b8c6d6",
	      "icon": "#36485c",
	      "text": "#36485c"
	    },
	    "paddingX": 16,
	    "paddingY": 16
	  },
	  "string": {
	    "label": "Label"
	  },
	  "linkN": {
	    "borderWeight": 1,
	    "gap": 4,
	    "height": 1,
	    "inverse": {
	      "border": "#ffffff",
	      "text": "#f5f7fa"
	    },
	    "neutral": {
	      "border": "#596d84",
	      "text": "#36485c"
	    },
	    "padding": 2,
	    "success": {
	      "border": "#275e43",
	      "text": "#275e43"
	    }
	  },
	  "listN": {
	    "background": {
	      "accentBlue": "#e6f1fc",
	      "accentGreen": "#ebf2ef",
	      "neutral": "#ffffff",
	      "selected": "#e6edf5"
	    },
	    "border": "#c8d3e0",
	    "borderWeight": {
	      "medium": 2,
	      "small": 1
	    },
	    "gap": {
	      "large": 12,
	      "medium": 8,
	      "small": 4,
	      "xsmall": 2
	    },
	    "paddingR": 8,
	    "paddingX": {
	      "medium": 12,
	      "small": 4
	    },
	    "paddingY": 12,
	    "radius": 8,
	    "textContent": "#475a70",
	    "textLabel": "#36485c"
	  },
	  "messageN": {
	    "borderRadius": 8,
	    "critical": {
	      "background": "#f0c4cd"
	    },
	    "gap": {
	      "large": 16,
	      "medium": 8,
	      "small": 4,
	      "xsmall": 2
	    },
	    "info": {
	      "background": "#c0d8f0"
	    },
	    "neutral": {
	      "background": "#e6edf5",
	      "textBody": "#475a70",
	      "textHeading": "#2e3a47"
	    },
	    "paddingX": 8,
	    "paddingY": 12,
	    "success": {
	      "background": "#d1e0d9"
	    },
	    "warning": {
	      "background": "#f3d8c0"
	    }
	  },
	  "navigationBarN": {
	    "background": "#ffffff",
	    "border": "#c8d3e0",
	    "borderWeight": 1,
	    "gap": 8,
	    "paddingY": 20,
	    "text": "#36485c"
	  },
	  "pillN": {
	    "critical": {
	      "background": "#f0c4cd",
	      "text": "#980b29"
	    },
	    "discovery": {
	      "background": "#e9e1ce",
	      "text": "#72623e"
	    },
	    "gap": 4,
	    "height": {
	      "large": 27,
	      "medium": 21,
	      "small": 19
	    },
	    "info": {
	      "background": "#c0d8f0",
	      "text": "#21588f"
	    },
	    "neutral": {
	      "background": "#e6edf5",
	      "text": "#36485c"
	    },
	    "paddingX": {
	      "large": 2,
	      "medium": 2,
	      "small": 1
	    },
	    "paddingY": 8,
	    "radius": 300,
	    "recur": {
	      "background": "#d7cee9",
	      "text": "#3b2566"
	    },
	    "success": {
	      "background": "#d1e0d9",
	      "text": "#275e43"
	    },
	    "warning": {
	      "background": "#f3d8c0",
	      "text": "#8e4d14"
	    }
	  },
	  "priceN": {
	    "gap": 4,
	    "textDiscount": "#275e43",
	    "textRegular": "#2e3a47",
	    "textSubtle": "#475a70"
	  },
	  "productCardN": {
	    "background": "#ffffff",
	    "gap": {
	      "medium": 8,
	      "small": 4,
	      "xsmall": 2
	    },
	    "paddingX": 12,
	    "paddingY": {
	      "medium": 12,
	      "small": 4
	    },
	    "radius": 8,
	    "text": "#475a70",
	    "title": "#2e3a47"
	  },
	  "productImageN": {
	    "_11": {
	      "large": {
	        "borderRadius": 8,
	        "height": 110,
	        "width": 110
	      },
	      "medium": {
	        "borderRadius": 4,
	        "height": 88,
	        "width": 88
	      },
	      "small": {
	        "borderRadius": 4,
	        "height": 64,
	        "width": 64
	      },
	      "xlarge": {
	        "borderRadius": 16,
	        "height": 200,
	        "width": 200
	      },
	      "xsmall": {
	        "borderRadius": 4,
	        "height": 42,
	        "width": 42
	      },
	      "xxlarge": {
	        "borderRadius": 16,
	        "height": 335,
	        "width": 335
	      },
	      "xxsmall": {
	        "borderRadius": 4,
	        "height": 32,
	        "width": 32
	      }
	    },
	    "_12": {
	      "xxsmall": {
	        "borderRadius": 4,
	        "height": 64,
	        "width": 32
	      }
	    },
	    "background": "#ffffff",
	    "fSbadge": {
	      "background": "#ebf2ef",
	      "icon": "#275e43",
	      "medium": {
	        "height": 24,
	        "icon": {
	          "height": 16,
	          "width": 16
	        },
	        "padding": 4,
	        "width": 24
	      },
	      "small": {
	        "height": 12,
	        "icon": {
	          "height": 8,
	          "width": 8
	        },
	        "padding": 2,
	        "width": 12
	      }
	    },
	    "padding": 4,
	    "status": {
	      "critical": "#feeef2",
	      "height": 20,
	      "neutral": "#f5f7fa",
	      "warning": "#fff3e8",
	      "width": 20
	    }
	  },
	  "radioN": {
	    "background": {
	      "default": "#ffffff",
	      "selected": "#212933"
	    },
	    "border": "#596d84",
	    "borderRadius": 300,
	    "borderWeight": 1,
	    "gap": 16,
	    "height": {
	      "large": 34,
	      "small": 20
	    },
	    "text": "#36485c",
	    "width": {
	      "large": 34,
	      "small": 20
	    }
	  },
	  "searchN": {
	    "background": "#f5f7fa",
	    "borderRadius": 8,
	    "gap": 8,
	    "height": {
	      "large": 44,
	      "small": 24
	    },
	    "icon": "#36485c",
	    "paddingX": 16,
	    "text": "#36485c",
	    "width": {
	      "small": 24
	    }
	  },
	  "segmentedControlN": {
	    "background": "#e6edf5",
	    "backgroundSegment": "#ffffff",
	    "gap": 4,
	    "padding": 4,
	    "paddingX": 4,
	    "paddingY": 16,
	    "radius": 32,
	    "radiusSegement": 16,
	    "text": "#36485c"
	  },
	  "sheetN": {
	    "backgroundScrim": "#0000001f",
	    "backgroundSheet": "#ffffff",
	    "gap": {
	      "large": 20,
	      "medium": 12,
	      "small": 4
	    },
	    "grabber": {
	      "background": "#c8d3e0",
	      "borderRadius": 4,
	      "height": 4,
	      "width": 44
	    },
	    "paddingX": {
	      "large": 20,
	      "medium": 16,
	      "small": 8
	    },
	    "paddingY": {
	      "medium": 20,
	      "small": 8
	    },
	    "radius": 32,
	    "textSubtitle": "#475a70",
	    "textTitle": "#36485c"
	  },
	  "snackbarN": {
	    "background": "#212933",
	    "gap": 16,
	    "paddingBottom": 16,
	    "paddingLeft": 12,
	    "paddingRight": 8,
	    "paddingY": 8,
	    "radius": 8,
	    "textLabel": "#ffffff"
	  },
	  "space": {
	    "gap": {
	      "large": 20,
	      "medium": 16,
	      "small": 12,
	      "xlarge": 24,
	      "xsmall": 8,
	      "xxlarge": 32,
	      "xxsmall": 4,
	      "xxxlarge": 40
	    },
	    "padding": {
	      "large": 16,
	      "medium": 12,
	      "small": 8,
	      "xlarge": 20,
	      "xsmall": 4
	    }
	  },
	  "statusN": {
	    "borderRadius": 4,
	    "critical": {
	      "background": "#f0c4cd",
	      "icon": "#980b29",
	      "text": "#800d25"
	    },
	    "gap": {
	      "medium": 8,
	      "small": 4
	    },
	    "height": {
	      "medium": 34,
	      "small": 24
	    },
	    "icon": {
	      "height": 8,
	      "radius": 300,
	      "width": 8
	    },
	    "info": {
	      "background": "#c0d8f0",
	      "icon": "#21588f",
	      "text": "#194673"
	    },
	    "neutral": {
	      "background": "#e6edf5",
	      "icon": "#36485c",
	      "text": "#2e3a47"
	    },
	    "paddingX": 8,
	    "success": {
	      "background": "#d1e0d9",
	      "icon": "#275e43",
	      "text": "#244c38"
	    },
	    "warning": {
	      "background": "#f3d8c0",
	      "icon": "#8e4d14",
	      "text": "#784213"
	    }
	  },
	  "tabNavN": {
	    "active": "#ebf2ef",
	    "background": "#ffffff",
	    "border": "#c8d3e0",
	    "borderWeight": 1,
	    "gap": 4,
	    "paddingB": 16,
	    "paddingT": 12,
	    "paddingY": 20,
	    "radius": 16,
	    "text": "#36485c"
	  },
	  "tabN": {
	    "border": "#b8c6d6",
	    "borderActive": "#307553",
	    "borderWeight": 1,
	    "borderWeightActive": 2,
	    "gap": 32,
	    "paddingX": 16,
	    "paddingY": 20,
	    "text": "#36485c"
	  },
	  "toggleN": {
	    "button": {
	      "background": "#ffffff",
	      "height": 24,
	      "paddingX": 2,
	      "paddingY": 2,
	      "width": 24
	    },
	    "gap": 12,
	    "icon": {
	      "height": 16,
	      "width": 16
	    },
	    "radius": 300,
	    "text": "#36485c",
	    "track": {
	      "backgroundDefault": "#307553",
	      "backgroundDisabled": "#c8d3e0",
	      "height": 28,
	      "width": 52
	    }
	  },
	  "tooltipN": {
	    "surface": "#2e3a47",
	    "textBody": "#f5f7fa",
	    "textHeading": "#ffffff"
	  }
	};
	
	return lightMobile375;
}

exports.__require = requireLightMobile375;
//# sourceMappingURL=light-mobile375.cjs.map
